import { useCallback } from "react";
import * as yup from "yup";

const useYupValidationResolver = (validationSchema: yup.ObjectSchema<any>) =>
  useCallback(
    async (data: any) => {
      try {
        const values: any = await validationSchema.validate(data, {
          abortEarly: false,
        });

        return {
          values,
          errors: {},
        };
      } catch (error) {
        const validationErrors = error as yup.ValidationError;
        return {
          values: {} as any,
          errors: validationErrors.inner.reduce(
            (allErrors, currentError: any) => ({
              ...allErrors,
              [currentError.path]: {
                type: currentError.type ?? "validation",
                message: currentError.message,
              },
            }),
            {}
          ),
        };
      }
    },
    [validationSchema]
  );

export default useYupValidationResolver;
